/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { OverflowCarousel } from '@coursera-web/cds-labs';

import { breakpoints } from '@coursera/cds-core';

import type { DomainsModuleFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import Section from 'bundles/front-page/components/Section';
import DomainPill from 'bundles/front-page/redesign-modules/domains/DomainPill';
import getDomainData from 'bundles/unified-common/utils/getDomainData';

import _t from 'i18n!nls/front-page';

type Props = {
  content?: DomainsModuleFragment;
};

const styles = {
  pills: css`
    display: flex;
    gap: var(--cds-spacing-100);
    flex-wrap: wrap;

    ${breakpoints.down('sm')} {
      flex-wrap: nowrap;
    }
  `,
};

const DomainsModuleRenderer = ({ content }: Props) => {
  const { title: moduleTitle } = content ?? {};
  const domains = getDomainData();

  return (
    <Section title={moduleTitle ?? _t('Explore categories')} dataTestId="domain-pills">
      <OverflowCarousel css={styles.pills} shouldAllowSpaceForHoverItems>
        {domains.map((domain) => (
          <DomainPill key={domain.id} {...domain} />
        ))}
      </OverflowCarousel>
    </Section>
  );
};

export default DomainsModuleRenderer;
